import { render, staticRenderFns } from "./ToGoBack.vue?vue&type=template&id=9ef7c4d2&scoped=true"
import script from "./ToGoBack.vue?vue&type=script&lang=js"
export * from "./ToGoBack.vue?vue&type=script&lang=js"
import style0 from "./ToGoBack.vue?vue&type=style&index=0&id=9ef7c4d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ef7c4d2",
  null
  
)

export default component.exports